<template>
  <div class="forgot-password">
    <div class="title">{{forgotPasswordTip}}</div>
    <div class="input">
      <div class="input-vp">
        <i class="icon"></i>
        <input type="text" class="email input-view" placeholder="Enter your Email" v-model="email" @keydown.enter.prevent="forgotClick"/>
      </div>
    </div>
    <div class="btn btn_forgot" @click="forgotClick">{{nextTip}}</div>
    <Foot :type="'or Sign in'" :isEmail="false" style="margin-top: 25px;margin-bottom: 45px;"></Foot>
  </div>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
  import { Message } from 'element-ui'
  import Foot from '../components/Foot'
  // import translate from '../common/Translate'
  export default {
    data () {
      return {
        email: '',
        forgotPasswordTip: 'Forgot Password',
        nextTip: 'Next'
      }
    },
    components: {
      Foot
    },
    methods: {
      forgotClick () {
        this.$emit('show')
        axios.post('/proxy-api/client/user/index/reset-password', qs.stringify({
          email: this.email
        }))
        .then((result) => {
          console.log(result)
          if (result.data.status === '0') {
            this.$emit('hide')
            setTimeout(() => {
              location.href = './'
            }, 1000)
            Message({
              message: 'Please check your email.',
              type: 'success'
            })
          } else {
            this.$emit('hide')
            Message({
              message: result.data.msg,
              type: 'error'
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.$emit('hide')
          Message({
            message: 'Warning!',
            type: 'warning'
          })
        })
      }
    }
  }
</script>

<style lang="less" scoped>
	@import '../../assets/css/_mixin.less';
  .forgot-password {
    .white-bg();
    min-height: 460px;
    margin-top: -230px;
    .title {
      height: 80px;
      font-size: 40px;
      text-align: center;
      color: #888;
      margin: 40px 0 30px;
    }
    .input {
      width: 380px;
      margin: 0 auto;
      .input-vp {
        border: 1px solid #ccc;
        height: 44px;
        display: flex;
        .icon {
          display: block;
          height: 100%;
          width: 20px;
          margin: 0 10px 0 20px;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
          &:first-child {
            background-image: url("../../assets/images/email@2x.png");
          }
        }
        &:not(:last-child) {
          border-bottom: none;
        }
        .input-view {
          height: 100%;
          width: 320px;
          border:none;
          font-size: 16px;
          outline: none;
        }
      }
    }
    .btn {
      width: 300px;
      height: 44px;
      margin: 60px auto 30px;
      border-radius: 5px;
      background: green;
      color: #fff;
      font-size: 18px;
      line-height: 44px;
      text-align: center;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// genericForgotpassword.vue?87f99ef0